//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { makeStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import FormControl from "@material-ui/core/FormControl";
import { CircularProgress } from "@material-ui/core";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Switch } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';
import {useTranslation} from 'react-i18next';

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";

//Custom Css + Images
import "./team.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import Edit from "../../Assets/edit.png";
import DeleteG from "../../Assets/deleteG.png";
import EditG from "../../Assets/editG.png";
import help from '../../Assets/help_icon.png';

import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "7px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
      backgroundColor: "#818181",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


//Main Function
function Group({isOnboarding=false}) {
  let { t } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let data = useSelector((state) => state.companyReducer.company);
  let company = useSelector((state) => state.companyReducer.company);
  let data2 = useSelector((state) => state.userReducer.user);
  const [currentCompany, setCurrentCompany] = useState(data);
  const [btnLoader, setBtnLoader] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companiesArr, setCompaniesArr] = useState([]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [signatureUrl, setSignatureUrl] = useState("");
  const [userData, setUserData] = useState(data2);
  const [packageDetails, setPackageDetails] = useState(null);
  const [token, setToken] = useState(data2.token);
  const [currentCompanyName, setCurrentCompanyName] = React.useState("");
  const [organizationId, setOrganizationId] = useState(data2.organization_id);
  const [editMode, setEditMode] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentEditUser, setCurrentEditUser] = useState("");
  const [selectedUsers , setSelectedUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [groups, setGroups] = useState(null);
  const [permissions_obj, setPermissionObj] = useState({});
  const [groupName, setGroupName] = useState("");
  const history = useHistory();
  const [teamData, setTeamData] = useState({
    first_name: "",
    last_name: "",
    job_title: "",
    email: "",
    password: "",
    role:"admin",
    confirmPassword: "",
    profilePic:null,
    signature_filename: "",
    signature: null,
  });
  let [errorObj, setErrorObj] = useState({
    first_name: "",
    last_name: "",
    job_title: "",
    role:"",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",

  });
  const [values, setValues] = React.useState({
    showPassword: false,
    showPasswordConfirm: false,
  });
  const dispatch = useDispatch();

  function handleInputChange(event) {
    let { name, value } = event.target;
    setTeamData({
      ...teamData,
      [name]: value,
    });
  }

  function handlePhoneInputChange(value) {
    console.log(value);
    setTeamData({
      ...teamData,
      phone: value,
    });
  }

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowPasswordConfirm = () => {
    setValues({ ...values, showPasswordConfirm: !values.showPasswordConfirm });
  };

  const handleCompanyChange = (value) => {
    setSelectedUsers([]);
    console.log(value.target.value);
    const index = companies.findIndex((item) => item.id === value.target.value);
    console.log(index);
    console.log("value", companies[index]);
    setCurrentCompanyName(companies[index].id);
    getUsers(companies[index].id);
    getGroups(companies[index].id)
    setSelectedUsers([]);
  };


  const getUsers = (CompanyID) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: CompanyID,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let arr = [];
          response.data.map((item) => {
            let obj = {
              first_name: item.first_name,
              last_name: item.last_name,
              id: item.id,
              checked: false,
            };
            arr.push(obj);
          });
          setTeams(arr);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            getUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };






    async function logout() {
    console.log("DELETE 1 CALLED");
    let localstorage = localStorage.getItem("UserData");

    let data = JSON.parse(localstorage);
    fetch(GlobalApi + "/DeviceRecord/delete_device_record", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + data.token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        device_record_id: data.device_id,
      }),
    })
      .then((res) => res.json())
      .then(async (resJson) => {
        console.log("DELETE RESPONSE IF DEVICE API", resJson);

        console.log("all Dispatches Called");
        // dispatch(removeUser());
        // dispatch(removeCompany());
        // dispatch(removeCompanyArr());
        // dispatch(removeIndustryArr());
        history.replace("/signin");
        localStorage.clear();
      })
      .catch((error) => console.log("error", error));
  }

  async function removeUser(userId) {
    let params1 = {
      group_id: userId,
    };
    let query = Object.keys(params1)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params1[k]))
      .join("&");

    swal({
      title: t("Are you sure?"),
      text: t("All Data connected to this group will be deleted"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        fetch(GlobalApi + "/companygroups/delete_group?" + query, {
          method: "get",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          })
        })
          .then((response) => response.json())
          .then(async (res) => {
            console.log("remove user response >>>>", res);
            if (res.msg === "success") {
              await swal(t("Success"), t("Group has been removed successfully"), "success");
              getGroups(currentCompanyName);
            } else {
              // alert(res.err);
            }
          })
          .catch((err) => console.log(err));

      } else {
        console.log("Canceled");
      }
    });
    
  }

  const editUser = (key, userId) => {
    setEditMode(true);
    let currentUser = groups[key];
    setCurrentEditUser(currentUser.id);
    console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXX",currentUser)
    setGroupName(currentUser.group_name);
    setSelectedUsers(currentUser.user_id);
  };

  const handleCancel = () => {
    setEditMode(false);
    setSelectedUsers([]);
    setGroupName("");
  };

  const resetFields = () => {
    setTeamData({
      first_name: "",
      last_name: "",
      job_title: "",
      email: "",
      role:"admin",
      password: "",
      confirmPassword: "",
      signature_filename: "",
      signature: null,
    });
    setPhoneNumber("");
  };

  async function getCompaniesDetail(Token, OrganizationId, UserData) {
    let params1 = {
      organization_id: OrganizationId,
    };
    let query1 = Object.keys(params1)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params1[k]))
      .join("&");

   
      
      let getPermissions = await fetch(
        GlobalApi + "/Permission/get_all_company_permissions?" + query1,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + Token,
            "Content-Type": "application/json",
          },
        }
      );
      let permissionsJson = await getPermissions.json();
      if (permissionsJson.status === "Success") {
        let finalArray = await permissionsJson.data.map((item) => {
          return {...item,role:'admin'}
        });

        console.log("**************** Companies>>>>>>>",finalArray);

        setCompanies(finalArray);
      }
   

    // else if (userData?.super_admin == false) {
    //   console.log('NOt Super Admin user >>>',)
    //   let getPermissions = await fetch(Global.apiUrl + '/Permission/get_all_company_permissions?' + query1, {
    //     method: 'GET',
    //     headers: {
    //       Authorization: 'Bearer ' + token,
    //       'Content-Type': 'application/json',
    //     },
    //   });
    //   let permissionsJson = await getPermissions.json();
    //   console.log('single company >>>>>>', permissionsJson);
    //   if (permissionsJson.status === 'Success') {
    //     if (handleGlobelCompanies != undefined) {
    //       handleGlobelCompanies(permissionsJson.data)
    //     }
    //     let industry_data = [];
    //     userData.companies.map(v => {
    //       industry_data.push({
    //         label: v.company_name,
    //         value: v.id,
    //       })
    //     })
    //     // let nameComp = reqJsonCompanies.companies[0].id;
    //     // console.log('nameComp >>>>', nameComp);
    //     setCompanies(industry_data);
    //     // setCompanies([{
    //     //    label:reqJsonCompany.company.company_name,
    //     //    value:reqJsonCompany.company.id
    //     // }]);
    //     setCompaniesValue({
    //       ...companiesValue,
    //       main_comp: industry_data[0].value,
    //       super_admin: false
    //     })
    //     if(currentRoute === 'TeamScreen'){
    //       fetchCompanyUsers(industry_data[0].value)
    //     }
    //   }
    // }
  }

  const getTeamData = (companyId) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let tokenNew = data.token;

    let params = { company_id: companyId };

    console.log("COMPANY ID >>>>>>>>>>>>,", companyId);

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + tokenNew,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if(response.msg == "success"){
        console.log("RESPONSE TEAM >>>>", response);
        dispatch(addTeam(response));
        setTeams(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  //let data = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
       setCurrentCompany(data);
       setCurrentCompanyName(data.id);
       getUsers(data.id);
       getGroups(data.id)
    },
    [data.id]
  );



  useEffect(
    () => {
      getCompaniesDetail(data2.token, data2.organization_id, data2);
    },
    [data2.user_id]
  );

  useEffect(() => {
    getPackageDetails()
   
  }, [])

  
  useEffect(() => {
    getPermissions()
    
  }, [company?.id])


    
  const getGroups = (companyID) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: companyID};
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/companygroups/get_all_company_groups?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log("response of group",response);
          if (response.msg === "success") {
         setGroups(response.groups);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getGroups();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };
  
  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  
  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }


  async function userStatusChange(status, userId, key) {
    console.log("status", status);
    console.log("user Id", userId);
    if (status == "active") {
      let _teams = [...teams];
      _teams[key].status = "deactivated";
      setTeams(_teams);
      try {
        let userDeactive = await fetch(GlobalApi + "/user/deactivate_users", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            user_id: userId,
          }),
        });
        let response = await userDeactive.json();
        console.log("Deactive user >>>>>", response);
        if (response.status === "Success") {
          await getTeamData(data.id);
          swal(t("Success"), t("Group Member Status changed succesfully"), "success");
           if(userId == data2.user_id){
            logout()
          }
        }
      } catch (error) {
        console.log("Error :::", error);
      }
    } else if (status == "deactivated") {
      let _teams = [...teams];
      _teams[key].status = "active";
      setTeams(_teams);
      try {
        let userDeactive = await fetch(GlobalApi + "/user/activate_users", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            user_id: userId,
          }),
        });
        let response = await userDeactive.json();
        console.log("Active user >>>>>", response);
        if (response.status === "Success") {
          await getTeamData(data.id);
          swal(t("Success"), t("Group Member Status changed Successfully"), "success");

          //  setUserData({
          //   ...userData,
          //   status:'active'
          // })
        }
      } catch (error) {
        console.log("Error :::", error);
      }
    }
  }




  const handleChange = (event) => {
    setSelectedUsers(event);
  };

  const handleSubmit = (e) => {
    let localstorage = localStorage.getItem("UserData");
    var localData = JSON.parse(localstorage);

    // return and array of selected users ids
    let selectedUsersIds = selectedUsers.map((user) => user.id);

    setBtnLoader(true);
    if (!editMode) {

      if (groupName == "") {
        swal(t("Error"), t("Group Name is Required"), "error");
        setBtnLoader(false);
        return;
      }
      if (selectedUsersIds.length < 2) {
        swal(t("Error"), t("Select Atleast 2 Users to Create Group"), "error");
        setBtnLoader(false);
        return;
      }

      console.log( "company_id", currentCompanyName,
        "user_id" ,selectedUsers,
        "group_name", groupName,)
    
      fetch(GlobalApi + "/companygroups/create_company_groups", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          company_id: currentCompanyName,
          user_id:selectedUsersIds,
          group_name: groupName,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          console.log("Created Group >>>>", res);
          if (res.msg === "success") {
            setBtnLoader(false);
            swal(t("Success"), t("Group Created Successfully"), "success");
            getGroups(currentCompanyName);
            setSelectedUsers([]);
            setGroupName("");
          } else {
            swal(t("Error"), res.error, "error");
            setBtnLoader(false);
          }
        })
        .catch((err) => {
          console.log("catch?????????????????",err)
          swal(t("Error"), err.error, "error");
          setBtnLoader(false);
        });
    } else if (editMode) {

      // remove duplicates from selectedUsersIds
      let uniqueSelectedUsersIds = [...new Set(selectedUsersIds)];

     

      if (groupName == "") {
        swal(t("Error"), t("Group Name is Required"), "error");
        setBtnLoader(false);
        return;
      }
      if (uniqueSelectedUsersIds.length < 2) {
        swal(t("Error"), t("Select Atleast 2 Users to Create Group"), "error");
        setBtnLoader(false);
        return;
      }

   
      fetch(GlobalApi + "/companygroups/edit_group", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          group_id: currentEditUser,
          user_id:uniqueSelectedUsersIds,
          group_name: groupName,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          console.log("Created Group >>>>", res);
          if (res.msg === "success") {
            setBtnLoader(false);
            swal(t("Success"), t("Group Updated Successfully"), "success");
            getGroups(currentCompanyName);
            setEditMode(false);
            setSelectedUsers([]);
            setGroupName("");
          } else {
            swal(t("Error"), res.error, "error");
            setBtnLoader(false);
          }
        })
        .catch((err) => {
          console.log("catch?????????????????",err)
          swal(t("Error"), err.error, "error");
          setBtnLoader(false);
        });
      }
  };

  const classes = useStyles();
  return <div className={isOnboarding == true ? "scrollHidden" : ""} style={{ width: "100%", padding: isOnboarding == true ? (window.innerWidth > 500 ? "20px 1px 20px 20px" : "10px 1px 10px 10px") : "0px", backgroundColor: 'white', overflowX: "hidden", overflowY: "auto", height: "77vh  " }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: isOnboarding == true && "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", padding: isOnboarding == true ? "20px" : "20px 0px 0px " }}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={12} md={1} lg={1} style={{ textAlign: "center" }} />
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <p className="label2" style={{ color: Colors.globalColor8, marginTop: 0 }}>
                {t("Select Users to Add to Group")}
              </p>
              <Tooltip title="Help" style={{ marginTop: "10px" }}>
                <a href="https://www.uraudits.com/knowledge-center/team/" target="blank" style={{ color: Colors.globalColor8 }}>
                  <img src={help} height={25} style={{ marginLeft: "5px" }} />
                </a>
              </Tooltip>
            </div>

            <form>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="label1Team">{t("Select Company")}</p>
                  <FormControl style={{ width: "100%" }}>
                    <Select disabled={editMode} className="SelectBox2" style={{ width: "100%", backgroundColor: "#f7f9fb" } // id="demo-simple-select"
                      } value={currentCompanyName} onChange={(value) => handleCompanyChange(value)} variant="outlined" size="small">
                      {companies.map((item, index) => {
                        return <MenuItem value={item.id}>
                            {item.company_name}
                          </MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                  <p className="label1Team" style={{ marginBottom: 0 }}>
                    {t("Select Group Members")}
                  </p>
                  <Autocomplete  filterSelectedOptions  size="small" limitTags={1}
  id="multiple-limit-tags" fullWidth options={teams} style={{ width: "100%",paddingTop:"5px" }} autoHighlight getOptionLabel={(option) => `${option?.first_name} ${option?.last_name}`} renderOption={(option) => <React.Fragment>
                        {option.first_name} {option.last_name}
                      </React.Fragment>} multiple onChange={(e, value) => handleChange(value)} value={selectedUsers} renderInput={(params) => <TextField {...params} fullWidth variant="outlined" inputProps={{ ...params.inputProps }
                          // autoComplete: "new-password",
                        } />} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <p className="label1Team">Group Name</p>
                  <TextField className="inputTextBox groupNameBox" style={{height:'28px'}} fullWidth id="outlined-basic" name="first_name" InputProps={{ classes: { input: classes.resize } }} onChange={(e) => setGroupName(e.target.value)} variant="outlined" autoComplete={"off"} size="small" value={groupName} />
                </Grid>
               
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} style={{ marginTop: "20px" }}>
                  {editMode ? <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleSubmit(e)}>
                      {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {"Update Group"}
                    </Button> : <>
                      {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleSubmit(e)}>
                          {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {t("Add Group")}
                        </Button> : <Button variant="contained" type="submit" className="addBtn2" component="span" disabled={true} style={{ backgroundColor: "#dadada" }}>
                          {t("Add Group")}
                        </Button>}
                    </>}
                  &nbsp;
                  <Button variant="contained" className="cancelBtn" onClick={() => handleCancel()}>
                    {t("Cancel")}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2} style={{ textAlign: "center" }} />
        </Grid>

        <Grid container spacing={3} justifyContent="center">
          {isOnboarding == false && <Grid item xs={0} sm={0} md={1} lg={1} />}
          <Grid item xs={12} sm={12} md={isOnboarding == false ? 10 : 12} lg={isOnboarding == false ? 10 : 12}>
            {window.innerWidth > 500 && <br />}
            {window.innerWidth > 500 && <TableContainer style={{ backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }}>
                <Table sx={{ minWidth: 900 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <p className="label3" style={{ color: Colors.globalColor8,textTransform:'uppercase' }}>
                          {t("Group Name")}
                        </p>
                      </TableCell>
                      <TableCell align="left" style={{width:"50%"}}>
                        <p className="label3" style={{ color: Colors.globalColor8,textTransform:'uppercase' }}>
                          {t("Members")}
                        </p>
                      </TableCell>

                  
                      <TableCell align="center"> </TableCell>
                      <TableCell align="center"> </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groups == null && <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                        <CircularProgress style={{ color: Colors.globalColor8 }} />
                      </div>}
                    {groups != null && groups.map((item, index) => {
                        console.log("ITEM>>>>>>>>", item);
                        return <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 1 } }}>
                            <TableCell align="left" padding="normal">
                              {item.group_name}
                            </TableCell>
                            <TableCell align="left" padding="none">
                              {item?.user_id.map(
                                (v, i) => {
                                  if (i <= 2) {
                                    return (
                                      <div
                                        className="shadow"
                                        style={{
                                          height: 30,
                                          borderRadius:
                                            "50px",
                                          backgroundColor:
                                            Colors.globalColor9,
                                          color:
                                            "#043077",
                                          display:
                                            "inline-flex",
                                          justifyContent:
                                            "center",
                                          margin: 1,
                                          padding:
                                            "0px 10px",
                                          alignItems:
                                            "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            margin: 0,
                                            fontWeight:
                                              "bold",
                                            fontSize:
                                              "12px",
                                          }}
                                        >
                                          {v?.first_name +
                                            " " +
                                            v?.last_name}
                                        </p>
                                      </div>
                                    );
                                  } 
                                }
                              )}
                              {item?.user_id.length > 3 &&  <div
                                        style={{
                                          width: 30,
                                          height: 30,
                                          borderRadius:
                                            "50px",
                                          border:
                                            "1px solid #043077",
                                          color:
                                            "#043077",
                                          display:
                                            "inline-flex",
                                          justifyContent:
                                            "center",
                                          margin: 1,
                                          alignItems:
                                            "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            margin: 0,
                                            fontWeight:
                                              "bold",
                                            fontSize:
                                              "10px",
                                          }}
                                        >
                                          +
                                          {item?.user_id
                                            ?.length -
                                            3}
                                        </p>
                                      </div>}
                            </TableCell>

                            <TableCell padding="none" align="right" style={{ maxWidth: "100px" }}>
                              {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <IconButton aria-label="delete" onClick={() => removeUser(item.id)}>
                                  <img src={Delete} alt="delete" />
                                  <p className="label1Team" style={{ fontSize: 12 }}>
                                    {t("Remove")}
                                  </p>
                                </IconButton> : <IconButton disabled aria-label="delete">
                                  <img src={DeleteG} alt="delete" />
                                  <p className="label1Team" style={{ fontSize: 12 }}>
                                    {t("Remove")}
                                  </p>
                                </IconButton>}
                            </TableCell>
                            <TableCell padding="none" align="right" style={{ maxWidth: "100px" }}>
                              {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <IconButton aria-label="delete" onClick={() => editUser(index, item.id)}>
                                  <img src={Edit} alt="edit" />
                                  <p className="label1Team" style={{ fontSize: 12 }}>
                                    {t("Edit")}
                                  </p>
                                </IconButton> : <IconButton disabled aria-label="edit" onClick={() => editUser(index, item.id)}>
                                  <img src={EditG} alt="edit" />
                                  <p className="label1Team" style={{ fontSize: 12 }}>
                                    Edit
                                  </p>
                                </IconButton>}
                            </TableCell>
                          </TableRow>;
                      })}
                  </TableBody>
                </Table>
              </TableContainer>}

            {window.innerWidth <= 500 && <div>
                {teams == null && <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                    <CircularProgress style={{ color: Colors.globalColor8 }} />
                  </div>}
                {teams != null && teams.map((item, index) => {
                    console.log("ITEM>>>>>>>>", item);
                    return <div className="hover shadow" style={{ display: "flex", justifyContent: "space-between", border: "1px solid #dadada", padding: "10px", margin: "5px", flexDirection: "row", alignItems: "center", textAlign: "left", height: "220px", borderRadius: "5px", backgroundColor: "white", overflow: "hidden" }}>
                        <div style={{ display: "flex", height: "100%", flexDirection: "column", justifyContent: "space-between" }}>
                          <div>
                            <p
                              style={{
                                color: Colors.globalColor8,
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              Name
                            </p>

                            <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                              {item.first_name} {item.last_name}
                            </p>
                          </div>
                          {item.email && <div>
                              <p
                                style={{
                                  color: Colors.globalColor8,
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                Email
                              </p>
                              <p
                                style={{
                                  fontSize: "12px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                {item.email}
                              </p>
                            </div>}
                          {item.phone && <div>
                              <p
                                style={{
                                  color: Colors.globalColor8,
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                Phone{" "}
                              </p>
                              <p
                                style={{
                                  fontSize: "12px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                {item.phone}
                              </p>
                            </div>}

                          <div>
                            {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <>
                                <p
                                  style={{
                                    color: Colors.globalColor8,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  Action{" "}
                                </p>
                                {item.organization_id === null ? <Switch className="statusSwitchTeam" checked={item.status === "active"} onChange={() => userStatusChange(item.status, item.id, index)} name="checkedB" style={{ color: Colors.globalColor8 }} /> : <Switch className="statusSwitchTeamDis" checked={item.status === "active"} disabled name="checkedB" style={{ color: "grey" }} />}
                              </> : <Switch className="statusSwitchTeamDis" checked={item.status === "active"} disabled name="checkedB" style={{ color: "grey" }} />}
                          </div>

                          {item.country && <div>
                              <p
                                style={{
                                  color: Colors.globalColor8,
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                Country{" "}
                              </p>
                              <p
                                style={{
                                  fontSize: "12px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                {item.country}
                              </p>
                            </div>}
                        </div>

                        <div style={{ display: "flex", height: "100%", flexDirection: "column", justifyContent: "space-between" }}>
                          <div>
                            {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <>
                                {item.organization_id === null ? <IconButton aria-label="delete" onClick={() => removeUser(item.id)}>
                                    <img src={Delete} alt="delete" />
                                  </IconButton> : <IconButton disabled aria-label="delete">
                                    <img src={DeleteG} alt="delete" />
                                  </IconButton>}
                              </> : <IconButton disabled aria-label="delete">
                                <img src={DeleteG} alt="delete" />
                              </IconButton>}
                          </div>

                          {item.status == "active" && <div>
                              <DoneAllIcon style={{ color: "green" }} />
                            </div>}

                          <div>
                            {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <IconButton aria-label="delete" onClick={() => editUser(index, item.id)}>
                                <img src={Edit} alt="edit" />
                              </IconButton> : <IconButton disabled aria-label="edit" onClick={() => editUser(index, item.id)}>
                                <img src={EditG} alt="edit" />
                              </IconButton>}
                          </div>
                        </div>
                      </div>;
                  })}
              </div>}
            <br />
            <br />
          </Grid>
          {isOnboarding == false && <Grid item xs={0} sm={0} md={1} lg={1} />}
        </Grid>
      </div>
    </div>;
}


export default Group;
